<template>
  <el-container>
    <el-header class="animate__animated animate__fadeInDown">
      <h3 class="nesc_title40">{{ $t('lang.news') }}</h3>
    </el-header>
    <el-row v-loading="loading" type="flex" class="nesc_cont1360" style="flex-wrap: wrap;margin-left: auto;margin-right: auto">
      <el-col v-for="item in newsList" :key="item.NewsInfoId" class="n_news3li" :span="6" :xs="12">
        <router-link :to="{ name: 'newsDetail', params: { id: item.NewsInfoId, time: item.CreateTime }}" style="display: block">
          <div class="n_nesc3xin">
            <div class="n_nesc3pic">
              <img class="n_tou" src="../assets/image/syk3_h.png" alt="">
              <img class="n_shi" :src="imgServer + item.CoverImage" alt="guanwang.jpg">
            </div>
            <div class="n_nesc3wen">
              <p class="n_nesc3wen_p">{{ item.Title }}</p>
              <div class="n_nesc3date">{{ item.CreateTime }}</div>
              <div class="t_jiancir flex-row-center">
                <i class="el-icon-arrow-right" />
              </div>
            </div>
          </div>
        </router-link>
      </el-col>
    </el-row>
    <el-pagination :class="{hidePreBtn: curPage == 1, hideNextBtn: curPage == totalPage}" class="pcfy flex-row-center" hide-on-single-page :total="total" :page-size="pageSize" layout="prev, pager, next" @current-change="getNews" @prev-click="getNews" @next-click="getNews" />

    <el-row class="phfy" type="flex" justify="space-around">
      <el-col :span="8">
        <a v-if="curPage> 1 " @click="getNews(curPage - 1)">{{ $t('lang.previous') }}</a>
      </el-col>
      <el-col :span="8">
        <a v-if="curPage < totalPage" @click="getNews(curPage + 1)">{{ $t('lang.next') }}</a>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
export default {
  name: 'News',
  data: () => {
    return {
      newsList: [],
      loading: !0,
      total: 0,
      pageSize: 12,
      curPage: 1,
      totalPage: 0,
      imgServer: ''
    }
  },

  mounted() {
    this.imgServer = this.domainUrl
    this.getNews(1)
  },

  methods: {
    getNews(e) {
      e && (this.curPage = e)
      this.$http.post(this.isDevelop ? '/NewsList' : '/api/NewsService/NewsList', { page: e, limit: this.pageSize }).then(
          (responseNews) => {
            window.scrollTo(0, 0)
            responseNews.statusText == 'OK' && responseNews.data.data.length > 0 &&
            (this.newsList = responseNews.data.data || [], this.total = parseInt(responseNews.data.count), this.loading = !1,
                this.totalPage = parseInt(responseNews.data.count / this.pageSize) + 1)
          }
      ).catch(function() {
        this.newsList = []
      })
    }
  }

}
</script>
<style lang="scss">
@import "../assets/scss/pagination";
</style>
<style scoped lang="scss">
@import "../assets/scss/news";
.el-header {
  height: auto !important;
  margin: 70px 0 50px;
}

@media screen and (max-width: 1440px) {
  .el-container {
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 991px) {
  .el-header {
    margin: 40px 0;
  }
  .el-container {
    margin-bottom: 50px;
  }
}

</style>
